export function formatDate(date) {
    var d = new Date(date);
    return d.toDateString();
    
}